import { Action, ActionReducerMapBuilder, Draft, SerializedError } from '@reduxjs/toolkit'

import { IAsyncDownloadState } from './types'

interface IWithDownloadState {
  download: IAsyncDownloadState
}

type TRejectedAction = Action<string> & { error: SerializedError }

export const addDownloadExtraReducers = <S extends IWithDownloadState>(
  builder: ActionReducerMapBuilder<S>,
  downloadTypePrefix: string
) => {
  builder
    .addCase(`${downloadTypePrefix}/fulfilled`, (state: Draft<S>) => {
      state.download.status = 'success'
      state.download.percent = 100
      state.download.remainingBytes = 0
      state.download.finishedAt = Date.now()
    })
    .addCase(`${downloadTypePrefix}/rejected`, (state: Draft<S>, action: Action<string>) => {
      const { error } = action as TRejectedAction

      state.download.status = 'error'
      state.download.error = error.message || 'Download failed'
      state.download.finishedAt = Date.now()
    })
}
